// import Tealium from 'tealium-react-native';
// import {
//   Dispatchers,
//   Collectors,
//   TealiumEvent,
//   TealiumView,
//   // eslint-disable-next-line import/no-unresolved
// } from 'tealium-react-native/common';

import AnalyticsManager from '../AnalyticsManager';

class TealiumHelper {
  configure = (account, profile, environment, ...args) => {
    const config = {
      account,
      profile,
      environment,
      // dispatchers: [Dispatchers.Collect, Dispatchers.RemoteCommands, Dispatchers.TagManagement],
      // collectors: [
      //   Collectors.AppData,
      //   Collectors.DeviceData,
      //   Collectors.Lifecycle,
      //   Collectors.Connectivity,
      // ],
      ...args,
    };

    // Tealium.initialize(config);

    // Tealium.trackEvent = this.trackEvent;
    // Tealium.trackView = this.trackView;

    // AnalyticsManager.addAnalyticsInstance(Tealium);
  };

  trackEvent = (eventName, data = {}) => {
    // const event = new TealiumEvent(eventName, data);
    // Tealium.track(event);
  };

  trackView = (screenName, data = {}) => {
    // const view = new TealiumView(screenName, data);
    // Tealium.track(view);
  };

  addRemoteCommand = (remoteCommandId, remoteCommand) => {
    // if (Tealium.addRemoteCommand) {
    //   Tealium.addRemoteCommand(remoteCommandId, remoteCommand);
    // } else {
    //   console.error('addRemoteCommand is only available in tealium-react-native 1.0.8+');
    // }
  };
}

export default TealiumHelper;
